var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-video"},[_c('image-video-component',{attrs:{"alt":_vm.alt,"caption":_vm.caption,"image":_vm.image,"video-url":_vm.videoUrl,"sizes":_vm.dimensions,"use-picture":true,"auto-quality":'best'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }